import { VStack } from "@/components/Layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";
import { ITOperationCoreHeader as Header } from "./-components/Header";

export const Route = createFileRoute("/_staff/it-operation-core/_root")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <VStack className="h-full">
      <Header />
      <Outlet />
    </VStack>
  );
}
